class Runtime {
  #name;
  #engines = new Map();

  constructor(name) {
    this.#name = name;
  }

  get name() {
    return this.#name;
  }

  get engines() {
    return this.#engines;
  }

  registerEngine(prefix, engine) {
    this.#engines.set(prefix, engine);
    if (typeof engine.setRuntime === "function") {
      engine.setRuntime(this);
    }
    if (this._bridge) {
      this._bridge.registerPrefix(prefix, engine);
    }
  }

  create(config) {
    const prefix = config.namespace.split(":")[0];
    const engine = this.#engines.get(prefix);
    engine.create(config);
  }

  update(message) {
    const prefix = message.namespace?.split(":")[0] || this.#resolvePrefix(message.uid);
    const engine = this.#engines.get(prefix);
    engine.update(message);
  }

  destroy(message) {
    const prefix = message.namespace?.split(":")[0] || this.#resolvePrefix(message.uid);
    const engine = this.#engines.get(prefix);
    engine.destroy(message);
  }

  #resolvePrefix(uid) {
    for (const [prefix, engine] of this.#engines) {
      return prefix;
    }
  }
}

export { Runtime };
